export default __webpack_public_path__ + "static/media/loginbg.20131f0a.png";